// 故障报修单中需要报修的设备列表逻辑，缓存里取出来
import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'
import { DeviceItem } from '@/types/device'
import { CacheFaultBill, NetworkpointItem } from '@/types/fault'
import { SubmitAddress } from '@/types/address'
import { ImageInfo } from '@/types/public'
import { copy } from '@/utils/index'
import { AddressEditInfo } from '@/types/address'

export default function getCacheFaultBillInfo(): {
  cacheFaultBill: ComputedRef<CacheFaultBill>
  cacheFaultDevices: ComputedRef<DeviceItem[] | never[]>
  cacheCompleteDevices: ComputedRef<DeviceItem[] | never[]>
  cacheComponents: ComputedRef<DeviceItem[] | never[]>
  isHasFullInsurance: ComputedRef<boolean>
  cacheNetworkpoint: ComputedRef<NetworkpointItem>
  cacheDescribe: ComputedRef<string>
  cacheImgs: ComputedRef<ImageInfo[]>
  receiveExpress: ComputedRef<SubmitAddress>
  setReceiveAddress: (addressObj: AddressEditInfo) => void
} {
  const store = useStore()
  // const searchQuery = ref('')
  const cacheFaultBill = computed(() => {
    return store.state.faultBill
  })
  const cacheFaultDevices = computed(() => {
    return cacheFaultBill.value?.devices || []
  })
  // 整机，假设type为1的，我当它是整机，正常情况是有一个整机
  const cacheCompleteDevices = computed(() => {
    return cacheFaultDevices.value.filter((it: { type: number }) => it.type === 1)
  })
  // 非整机，假设type不为1为非整机
  const cacheComponents = computed(() => {
    return cacheFaultDevices.value.filter((it: { type: number }) => it.type !== 1)
  })
  // 是否拥有全保的设备选中
  const isHasFullInsurance = computed(() => {
    return cacheFaultDevices.value.some((it: { xcare: string }) => it.xcare !== '无')
  })
  // 维修网点
  const cacheNetworkpoint = computed(() => {
    if (cacheFaultBill.value?.networkpoint?.guid) {
      return cacheFaultBill.value.networkpoint
    } else {
      return null
    }
  })

  // 故障描述
  const cacheDescribe = computed(() => {
    return cacheFaultBill.value?.describe || ''
  })

  // 故障图片
  const cacheImgs = computed(() => {
    return cacheFaultBill.value?.imgs || []
  })
  // 收件信息
  const receiveExpress = computed(() => {
    return cacheFaultBill.value?.receiveExpress || null
  })
  // 设置收件信息
  const setReceiveAddress: (addressObj: AddressEditInfo) => void = (
    addressObj: AddressEditInfo
  ): void => {
    const { name, tel, province, city, county, addressDetail } = addressObj
    const item: SubmitAddress = {
      name,
      phone: tel,
      province,
      city,
      area: county,
      address: addressDetail,
    }
    const obj: CacheFaultBill = copy(cacheFaultBill.value)
    Object.assign(obj, {
      receiveExpress: item,
    })
    store.commit('setFaultBill', obj)
  }
  return {
    cacheFaultBill,
    cacheFaultDevices,
    cacheCompleteDevices,
    cacheComponents,
    isHasFullInsurance,
    cacheNetworkpoint,
    cacheDescribe,
    cacheImgs,
    receiveExpress,
    setReceiveAddress,
  }
}
